export default __webpack_public_path__ + "static/media/AllKindLogo.98e0dd75.png";